import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { DmpLogo } from '../brand/DmpLogo';
interface CngQrStickerProps {
  qrId: string;
  reg: string;
  size?: 'md' | 'sm';
  voided?: boolean;
}
export function CngQrSticker({
  qrId,
  reg,
  size = 'md',
  voided
}: CngQrStickerProps) {
  const sm = size === 'sm';
  return <div className={`relative flex flex-col overflow-hidden rounded-xl border-2 border-navy-800 bg-white shadow-sm ${sm ? 'w-[150px]' : 'w-[240px]'}`} data-id="element-658" data-mp="f3ud1ok2tcaq">
      <div className={`flex items-center gap-2 bg-navy-800 text-white ${sm ? 'px-2 py-1.5' : 'px-3 py-2.5'}`} data-id="element-659" data-mp="o37h21pfl8o2">
        <DmpLogo size={sm ? 22 : 34} data-id="element-660" data-mp="t20xa1w3rdrx" />
        <div className="leading-tight" data-id="element-661" data-mp="t33jvxme6u21">
          <p className={`font-semibold ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-662" data-mp="y1naibbxku0q">ঢাকা মেট্রোপলিটন পুলিশ</p>
          <p className={`font-mono font-bold tracking-widest text-gold ${sm ? 'text-[9px]' : 'text-sm'}`} data-id="element-663" data-mp="2uu6xmvrkwoqt">DMP</p>
        </div>
      </div>
      <div className={`flex items-center justify-between bg-bdgreen-600 text-white ${sm ? 'px-2 py-0.5' : 'px-3 py-1'}`} data-id="element-664" data-mp="2ztt8iyjxpswg">
        <span className={`font-mono font-extrabold tracking-[0.2em] ${sm ? 'text-xs' : 'text-xl'}`} data-id="element-665" data-mp="2ubnpsueimi4">CNG</span>
        <span className={`${sm ? 'text-[7px]' : 'text-[10px]'}`} data-id="element-666" data-mp="3u5lh09jg2r8f">যানবাহন যাচাই</span>
      </div>
      <div className={`flex justify-center ${sm ? 'p-2' : 'p-4'}`} data-id="element-667" data-mp="3p6in9l8x07fr">
        <QRCodeSVG value={`https://verify.dmp.gov.bd/q/${qrId}`} size={sm ? 96 : 168} level="H" fgColor="#081c3d" data-id="element-668" data-mp="3kath2z2e3sah" />
      </div>
      <div className={`border-t border-dashed border-navy-200 text-center ${sm ? 'px-2 pb-2 pt-1' : 'px-3 pb-3 pt-2'}`} data-id="element-669" data-mp="lpsamnituw53">
        <p className={`font-mono font-bold tracking-wider text-navy-900 ${sm ? 'text-[10px]' : 'text-base'}`} data-id="element-670" data-mp="btowejapb71s">{qrId}</p>
        <p className={`font-semibold text-navy-800 ${sm ? 'text-[9px]' : 'text-sm'}`} data-id="element-671" data-mp="7smxk3kp4x0c">{reg}</p>
        {!sm && <p className="mt-1 text-[10px] text-slate-500" data-id="element-672" data-mp="2wk68scokb0ne">ট্রাফিক পুলিশ যাচাইয়ের জন্য স্ক্যান করুন</p>}
      </div>
      <div className="flex h-1.5" data-id="element-673" data-mp="2sh9kc5cccabj">
        <span className="flex-1 bg-bdgreen-600" data-id="element-674" data-mp="2skfalnwphi8u" />
        <span className="w-6 bg-flagred" data-id="element-675" data-mp="2tz88gryj18fi" />
        <span className="flex-1 bg-bdgreen-600" data-id="element-676" data-mp="2u09iqu7pxqw6" />
      </div>
      {voided && <div className="absolute inset-0 flex items-center justify-center bg-white/70" data-id="element-677" data-mp="2yx9o12wqupm8">
          <span className="-rotate-12 rounded border-4 border-red-600 px-3 py-1 text-lg font-bold text-red-600" data-id="element-678" data-mp="2k0aeh9ic0mp4">বাতিল</span>
        </div>}
    </div>;
}